import * as z from "zod";
import { readSkillFiles } from "../skillFiles";
import { parseFrontMatter } from "../parseFrontMatter";
import { validateSkillBundle } from "../skills/spec";
import { mutator } from "./mutator";

export const publishSkillSchema = z.object({
  skillId: z.string(),
});

export const publishSkill = mutator({
  schema: publishSkillSchema,
  resolve: {
    skill: { kind: "skill", from: "skillId" },
  },
  permissions: [
    {
      permission: "skill:write",
      scopeId: ({ args }) => args.skill.id,
    },
  ],
  fn: async ({ tx, args: { skill } }) => {
    const files = await readSkillFiles(tx, skill.id);
    if (files["SKILL.md"]) {
      try {
        validateSkillBundle(files);
      } catch (error) {
        const file = files["SKILL.md"];
        const legacy =
          file.encoding === "utf8" ? parseFrontMatter(file.content) : null;
        if (
          Object.keys(files).length !== 1 ||
          !legacy ||
          legacy.attrs.name !== skill.name ||
          legacy.attrs.description !== skill.description ||
          legacy.body.trim() !== skill.instructions
        ) {
          throw error;
        }
      }
    }
    await tx.mutate.skills.update({
      id: skill.id,
      fresh: false,
    });
  },
});
